export default "__VITE_ASSET__BtCMjF46__"